<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>local_dining</md-icon>
      </div>
      <h4 class="title">
        Dinners
      </h4>
      <md-button
        class="md-dense md-primary"
        @click="addAllDays()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Create all Dates
      </md-button>
      <md-button
        class="md-dense md-primary"
        @click="addDay()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Add a Dinner
      </md-button>
    </md-card-header>
    <md-card-content>
      <!-- <md-table v-model="this.manifest.dinners" md-card> -->
      <md-table v-model="sortedDinners" md-card>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Date" class="col-date">
            <md-datepicker
              v-model="item.date"
              md-immediately
              :md-model-type="String"
            >
            </md-datepicker>
          </md-table-cell>
          <md-table-cell md-label="Day" class="col-day">
            <md-field>
              <md-input
                readonly
                :value="item.date | getDayFromDate"
                type="text"
              ></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Restaurant">
            <md-field class="option-select">
              <md-select v-model="item.restaurant_id" md-dense>
                <md-option
                  v-for="restaurant in restaurants"
                  :key="restaurant.id"
                  :value="restaurant.id"
                  >{{ restaurant.company }}</md-option
                >
              </md-select>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Time">
            <md-field>
              <md-input v-model="item.time" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Notes">
            <md-field>
              <md-input v-model="item.notes" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell>
            <md-button
              class="md-danger md-just-icon md-simple"
              @click.stop="removeItem(item)"
            >
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="top">Remove Entry</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
        <!-- </md-table-body> -->
        <md-table-empty-state
          md-label="Nothing to Show"
          :md-description="`We can't find any details to show.`"
        >
        </md-table-empty-state>
      </md-table>
      <md-button
        class="md-dense md-primary"
        @click="save"
        style="margin-top: 1rem"
      >
        <md-icon>save</md-icon>
        Save
      </md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import departureApi from "@/services/api/departure";
import restaurantApi from "@/services/api/restaurant";
import moment from "moment";
import _map from "lodash/map";
import _filter from "lodash/filter";

export default {
  props: {
    manifest: {
      itinerary: [],
      dinners: [],
      reservations: []
    },
    departure: {}
  },

  data() {
    return {
      restaurants: []
    };
  },

  computed: {
    sortedDinners() {
      return this.manifest.dinners
        .slice()
        .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
    }
  },

  methods: {
    addAllDays() {
      this.getAllDays()
        .filter(x => !_map(this.manifest.dinners, "date").includes(x))
        .forEach(this.addDay);
    },

    addDay(date = null) {
      this.manifest.dinners.push({
        date: date ? moment().format(date) : moment().format("YYYY-MM-DD"),
        restaurant_id: null,
        time: "",
        notes: ""
      });
    },

    getAllDays() {
      var dates = [];
      for (
        var m = moment(this.departure.start_date);
        m.isBefore(this.departure.end_date);
        m.add(1, "days")
      ) {
        dates.push(m.format("YYYY-MM-DD"));
      }
      return dates;
    },

    removeItem: function(item) {
      this.manifest.dinners.splice(this.manifest.dinners.indexOf(item), 1);
    },

    save() {
      departureApi
        .updateManifest(this.departure.id, this.manifest)
        .then(response => {
          this.$emit("manifestChanged", response.data.manifest);
          this.$notify({
            timeout: 2500,
            message: "Updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
    }
  },

  mounted() {},

  created() {
    restaurantApi.getRestaurants().then(response => {
      this.restaurants = response.data;
    });
  }
};
</script>

<style lang="scss">
.col-date {
  width: 250px;
}
.col-day {
  width: 300px;
}
</style>
